import log from '../logValidationError';

function getPath(pathPrefix, dataPath) {
	if (!pathPrefix && !dataPath) return '';

	if (!pathPrefix && dataPath.startsWith('.')) return `${dataPath.substr(1)} `;

	return `${pathPrefix}${dataPath} `;
}

/**
 * Run a validator against a value to determine its validity. If it is not valid, log an error.
 * @private
 * @param {Function} validator The validator built from one of the methods in ./build
 * @param {any} value The value to run the schema validation against
 * @param {Object} options
 * @param {string} options.pathPrefix Name of the value being validated. Optional
 * @param {string} options.errorPrefix Prefix for the error message
 * @returns {boolean} Whether the value passed validation
 */
function validateSchema(
	validator,
	value,
	{pathPrefix = '', errorPrefix = '', shouldLog = true} = {}
) {
	const isValid = validator(value);
	if (!isValid) {
		// If there are errors, only report the first one
		const [{dataPath, message, params: {level = 'error'} = {}}] = validator.errors;

		const path = getPath(pathPrefix, dataPath);
		const errorMessage = `${path}${message}`;

		if (shouldLog) log(`${errorPrefix}${errorMessage}`, {level, origin: 'validateSchema'});
	}
	return isValid;
}

export default validateSchema;
